import { Map } from "immutable"
import undoable from 'redux-undo'
import constants from '../containers/Constants'
import Immutable from 'immutable'
import commands from "../json/commands"

const buttonActions = (actions = Map({}), action) => {
    switch (action.type) {
        case 'ADD_ACTION_TO_BUTTON':
            var ret = actions;
            console.log(constants)
            if (!actions.has(action.preset)) {
                ret = actions.set(action.preset, Map.of(action.buttonID, Map.of(action.actionName, action.action)))
            } else {
                if (!actions.hasIn([action.preset, action.buttonID])) {
                    console.log("first action on button")
                    ret = actions.setIn([action.preset, action.buttonID], Map([
                        [action.actionName, action.action]
                    ]))
                } else if (actions.getIn([action.preset, action.buttonID]).size < constants.num_actions) {

                    if (!actions.hasIn([action.preset, action.buttonID, action.actionName])) {
                        console.log("nth action on button")
                        ret = actions.updateIn([action.preset, action.buttonID], map => map.set(action.actionName, action.action))
                    } else if (!actions.hasIn([action.preset, action.buttonID, action.actionName + " 2"])) {
                        console.log("duplicated action")
                        ret = actions.updateIn([action.preset, action.buttonID], map => map.set(action.actionName + " 2", action.action))
                    } else if (actions.hasIn([action.preset, action.buttonID, action.actionName + " 2"])) {
                        ret = actions.updateIn([action.preset, action.buttonID], map => map.set(action.actionName + " 3", action.action))

                    }
                }
            }
            return ret
        case 'REMOVE_ACTION_FROM_BUTTON':
            return actions.deleteIn([action.preset, action.buttonID, action.actionID]);

        case 'PASTE_BUTTON_ACTIONS':
            return actions.setIn([action.preset, action.buttonID], action.clipboard)

        case 'CLEAR_ACTIONS':
            return Map({})

        case 'MINIMIZE_ACTION':
            return actions.setIn([action.preset, action.buttonID, action.actionID, 'isMinimized'], true);

        case 'MAXIMIZE_ACTION':
            return actions.setIn([action.preset, action.buttonID, action.actionID, 'isMinimized'], false);

        case 'CHANGE_OPTION_VALUE':
            var ret = actions.asMutable()
            var tempAction = actions.getIn([action.preset, action.buttonID, action.actionID, 'options'])
            if (!tempAction.hasIn([action.optionID, "linked-parameter"])) {
                tempAction.forEach(function(map, key) {
                    if (map.get('linked-parameter') == action.optionID && map.get('linked-options').includes(parseInt(action.optionValue))) {
                        ret = ret.setIn([action.preset, action.buttonID, action.actionID, 'options', key, 'isHidden'], false)
                    } else if (map.get('linked-parameter') && (map.get('linked-parameter') == action.optionID && !map.get('linked-options').includes(parseInt(action.optionValue)))) {
                        ret = ret.setIn([action.preset, action.buttonID, action.actionID, 'options', key, 'isHidden'], true)
                    }
                })
            }
            ret.setIn([action.preset, action.buttonID, action.actionID, 'options', action.optionID, 'value'], action.optionValue)

            return ret.asImmutable()

        case 'CHANGE_EXECUTE_ON':
            return actions.setIn([action.preset, action.buttonID, action.actionID, 'executeOn'], action.executeOn)

        case 'LOAD_ACTIONS':
            console.log("in load actions", action.actions   )
            for (var preset in action.actions) {
                for (var button in action.actions[preset]) {
                    for (var command in action.actions[preset][button]) {
                        var curCommand = action.actions[preset][button][command]
                        if (command.includes(" 2") || command.includes(" 3")) {
                            command = command.substr(0, command.length - 2)
                        }
                        // var newCommand = commands["Ableton Commands"][command]
                        // if (newCommand !== undefined) {
                        //     for (var option in newCommand.options) {
                        //         if (!curCommand.options[option] || curCommand.options[option]["range"]["type"] != newCommand.options[option]["range"]["type"] || curCommand.options[option]["range"]["options"] != newCommand.options[option]["range"]["options"]) {
                        //             if (option == "Fade Time (ms)") {
                        //                 console.log("replacing fade")
                        //                 curCommand.options[option]["value"] = parseInt((parseInt(curCommand.options[option]["value"]) / 5000.) * 20)
                        //                 curCommand.options[option]["range"] = newCommand.options[option]["range"]
                        //             }
                        //             // else {
                        //             //     console.log("replacing", curCommand.options[option], newCommand.options[option])
                        //             //     curCommand.options[option]["range"]["options"] = newCommand.options[option]["range"]["options"]
                        //             // }
                        //         }
                        //     }
                        // }

                    }

                }
            }
            if (action.actions.present) {
                return Immutable.fromJS(action.actions.present)

            } else {
                return Immutable.fromJS(action.actions)
            }


        case 'COPY_PRESET':
            return actions.set(action.destination, actions.get(action.current));
        default:
            return actions;

    }
}

const undoableButtonActions = undoable(buttonActions)


export default undoableButtonActions